import React from 'react'
import BasicModalWindow from '../../components/BasicModalWIndow'
import ViewSingleIssuePage from './ViewSingleIssuePage'

interface IProps {
    issueId: number,
    shown: boolean,
    handleClose: () => void
}

export default function ViewIssueModal(props: IProps) {

    const { issueId, shown, handleClose } = props

    return(
        <BasicModalWindow
            shown={shown}
            title={"View issue"}
            message=""
            size="md"
            showHeader
            handleClose={handleClose}
            actionButtons={[
                {
                    label: "Close",
                    handleClose: true,
                    color: "error"
                }
            ]}
            pageOverlayStyle
        >
            {issueId && <ViewSingleIssuePage customId={issueId} hidePageHeadSection />}
        </BasicModalWindow>
    )
}